import { useLogout } from '../../lib/session';

interface AccessDeniedPanelProps {
  title?: string;
  description: string;
}

/**
 * Affiché quand la session est valide mais que l'Extranet API refuse l'accès
 * (403 sur `/v1/users/me` : session non-extranet, membre inactif, droits
 * révoqués) ou qu'aucun rôle n'est attribué. Pas de redirection automatique :
 * on laisse l'utilisateur se déconnecter, sans boucle.
 */
export const AccessDeniedPanel = ({ title = 'Accès refusé', description }: AccessDeniedPanelProps) => {
  const logout = useLogout();
  return (
    <div className="h-viewport flex items-center justify-center bg-zinc-50 px-6">
      <div className="text-center max-w-md flex flex-col gap-3">
        <h1 className="text-lg font-semibold text-zinc-900">{title}</h1>
        <p className="text-sm text-zinc-600">{description}</p>
        <button
          type="button"
          onClick={() => void logout()}
          className="self-center h-9 px-4 mt-2 text-sm font-medium bg-zinc-900 text-white rounded-md hover:bg-zinc-800 transition-colors"
        >
          Se déconnecter
        </button>
      </div>
    </div>
  );
};
